import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { ApiServiceProvider } from '../api/api-service';
// import _ from 'lodash';

@Injectable()
export class PageBuilderPageNotificationProvider {

  public SFGoAuth: any;
  public SFGoStorage: any;

  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;

  constructor(
    public _http: Http,
    private _storage: Storage,
    private _apiServiceProvider: ApiServiceProvider) { 
  }

  getPageNotification(companyCode): Promise<any> {
    return new Promise(async (resolve) => {
      const body = {
        companyCode: companyCode,
      }
      this._apiServiceProvider.apiPB('POST', null, body, '/app-pageNotification/getPageNotificationAll', false, true).then(async (response: any) => {
            console.log('Load Page Success');
            if (response.data) {
              this._storage.set('pageBuilderPageNotification', JSON.stringify(response.data));
              resolve(response.data);
            } else {
              let pageNotification = await this._storage.get("pageBuilderPageNotification"); 

              try {
                pageNotification = JSON.parse(pageNotification);
              } catch (e) {
                pageNotification = pageNotification;
              }

              // console.log("TCL: pageNotification Empty Data", pageNotification);

              if (pageNotification) {
                resolve(pageNotification);
              } else {
                pageNotification = await this._storage.set("pageBuilderPageNotification", JSON.stringify({})); 
                resolve(pageNotification);
                // console.log('TCL: pageNotification Storage Empty');
              }
            }
            resolve(response);
        }, async (error) => {
          let pageNotification = await this._storage.get("pageBuilderPageNotification"); 

          try {
            pageNotification = JSON.parse(pageNotification);
          } catch (e) {
            pageNotification = pageNotification;
          }
          
          console.log("Error Get Page Notification", error, pageNotification);

          if (pageNotification) {
            resolve(pageNotification);
          } else {
            pageNotification = await this._storage.set("pageBuilderPageNotification", JSON.stringify([])); 
            resolve(pageNotification);
            console.log('pageNotification Storage Empty');
          }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/pagebuilder/services/pagenotification/pagenotification-service.ts